import React from 'react';
import styled from 'styled-components';
import { BounceLoader } from 'halogenium';
import Lottie from 'react-lottie';
import { AccentColor } from 'helpers/AccentColorHelper';
import loadingAnimationData from 'assets/loading.json';

const StyledLoadingMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  padding-bottom: 1rem;
  ${props =>
    props.isCentered &&
    `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    `};
`;

const StyledLoadingMessagesInner = styled.div`
  margin: 1rem;
`;

export const LoadingIndicator = ({ text, isCentered, shouldRender }) => {
  if (!shouldRender) return null;
  return (
    <StyledLoadingMessagesContainer isCentered={isCentered}>
      <StyledLoadingMessagesInner>
        <BounceLoader color={AccentColor()} style={{ margin: 'auto' }} />
      </StyledLoadingMessagesInner>
      {text && <p>{text}</p>}
    </StyledLoadingMessagesContainer>
  );
};

const StyledLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: ${props => props.backgroundColor || 'transparent'};
  ${props =>
    props.isFullscreen &&
    `
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
  `};
`;

const StyledP = styled.p`
  text-align: center;
  font-size: 1.5rem;
`;

export const Loading = ({ shouldRender, lottieOptions, text, ...rest }) => {
  if (!shouldRender) return null;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <StyledLoadingContainer {...rest}>
      <Lottie options={{ ...defaultOptions, ...lottieOptions }} height={150} width={150} />
      {text && <StyledP>{text}</StyledP>}
    </StyledLoadingContainer>
  );
};
